import { parseSupportingContentItem } from "./SupportingContentParser";

import styles from "./SupportingContent.module.css";

interface Props {
    supportingContent: string[];
    isDarkMode: boolean;
}

export const SupportingContent = ({ supportingContent, isDarkMode }: Props) => {
    return (
        <ul className={styles.supportingContentNavList}>
            {supportingContent.map((x, i) => {
                const parsed = parseSupportingContentItem(x);

                return (
                    <li className={isDarkMode ? styles.supportingContentItemDark : styles.supportingContentItem}>
                        <h4 className={isDarkMode ? styles.supportingContentItemHeaderDark : styles.supportingContentItemHeader}>{parsed.title}</h4>
                        <p className={isDarkMode ? styles.supportingContentItemTextDark : styles.supportingContentItemText}>{parsed.content}</p>
                    </li>
                );
            })}
        </ul>
    );
};
